export default {"src":"/_next/static/media/pinterest.f75fc1ac.svg","height":62,"width":61,"blurWidth":0,"blurHeight":0};